module.exports = __webpack_public_path__ + "static/media/slide2.c8064deb.jpg";